/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const ArrowDown: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M12.7071 22.707L20.4141 15L19.0001 13.586L13.0001 19.586V2C13.0001 1.447 12.5521 1 12.0001 1C11.4481 1 11.0001 1.447 11.0001 2L11.0001 19.586L5.00006 13.586L3.58606 15L11.2931 22.707C11.6841 23.098 12.3161 23.098 12.7071 22.707Z'
      fill='currentColor'
    />
  </React.Fragment>
)
